import React, { useEffect, useState, useRef } from 'react';

const Loader = (props) => {
    return (<>
        {props.show == true ? <div className="loading d-flex justify-content-center align-items-center">
            <span className="loader3">Trailboss</span>
        </div> : ''}
    </>)
}

export default Loader;